/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import Map from './components/map/map.jsx';

const App = (props) => {
  return (
    <div>
      <Map config={props.config}/>
    </div>
  );
};

App.propTypes = {
  config: PropTypes.object,
};

export default App;
